import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { auth } from "../firebase/config";
import { migrateLocalDirectory } from "./knownPeople";

interface AuthContextType {
  // the anonymous account's uid, or null while the session is resolving
  uid: string | null;
}

const AuthContext = createContext<AuthContextType>({ uid: null });

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [uid, setUid] = useState<string | null>(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUid(user.uid);
        // carry any old localStorage directory into the cloud, once
        migrateLocalDirectory(user.uid).catch((e) =>
          console.error("directory migration failed", e)
        );
      } else {
        signInAnonymously(auth).catch((e) =>
          console.error("anonymous sign-in failed", e)
        );
      }
    });
    return unsub;
  }, []);

  return <AuthContext.Provider value={{ uid }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
